import type { SimulationService } from './index';
import delay from '../mockServiceDelay';
import { SimulationExecutionStatus, SimulationStatus } from '../../simulation/types';

const mockSimualtionService: SimulationService = {
  fetchSimulationDetail: async (simulationId) => {
    await delay();
    return Promise.resolve({
      simulationId: 'simulation_id_1',
      partnerId: '76abb3d4-8990-4f80-aa13-4c2007cb852a',
      name: 'Fedex',
      description: 'Simulating Adding Fedex',
      executionPriority: 'medium',
      executionStatus: 'waiting',
      simulationStatus: 'not_sure',
      simulationType: 'add_origin',
      includesHistoricalSelection: false,
      simulationStartDate: '2023-11-15T16:29:33.178Z',
      simulationEndDate: '2023-11-15T17:29:33.178Z',
      simulationSourceStartDate: '2022-11-13T17:29:33.178Z',
      simulationSourceEndDate: '2022-12-13T17:29:33.178Z',
      createdBy: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
      lastUpdatedBy: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
      creationTimestamp: '2023-11-13T17:29:33.178Z',
      lastUpdatedTimestamp: '2023-11-13T17:29:33.178Z',
      expectedBatches: 10,
      finalBatchStatusCount: 5,
      pendingBatchStatusCount: 5,
      simulationEvents: [],
      simulationBatchCreatorJobs: [],
    } as any);
  },
  fetchSimulations: async () => {
    await delay();
    return Promise.resolve([
      {
        simulationId: 'simulation_id_1',
        partnerId: '76abb3d4-8990-4f80-aa13-4c2007cb852a',
        name: 'Fedex',
        description: 'Simulating Adding Fedex',
        executionPriority: 'medium',
        executionStatus: 'waiting',
        simulationStatus: 'not_sure',
        simulationType: 'add_origin',
        includesHistoricalSelection: false,
        simulationStartDate: '2023-11-15T16:29:33.178Z',
        simulationEndDate: '2023-11-15T17:29:33.178Z',
        simulationSourceStartDate: '2022-11-13T17:29:33.178Z',
        simulationSourceEndDate: '2022-12-13T17:29:33.178Z',
        createdBy: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
        lastUpdatedBy: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
        creationTimestamp: '2023-11-13T17:29:33.178Z',
        lastUpdatedTimestamp: '2023-11-13T17:29:33.178Z',
        expectedBatches: 10,
        finalBatchStatusCount: 5,
        pendingBatchStatusCount: 5,
        simulationEvents: [],
        simulationBatchCreatorJobs: [],
      } as any,
      {
        simulationId: 'simulation_id_2',
        partnerId: '76abb3d4-8990-4f80-aa13-4c2007cb852a',
        name: 'Add Origin',
        description: 'Simulating Adding an origin in kansas',
        executionPriority: 'high',
        simulationType: 'add_origin',
        executionStatus: 'waiting',
        simulationStatus: 'not_sure',
        includesHistoricalSelection: false,
        simulationStartDate: '2023-11-15T16:29:33.178Z',
        simulationEndDate: '2023-11-15T17:29:33.178Z',
        simulationSourceStartDate: '2022-11-13T17:29:33.178Z',
        simulationSourceEndDate: '2022-12-13T17:29:33.178Z',
        createdBy: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
        lastUpdatedBy: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
        creationTimestamp: '2023-11-13T17:29:33.178Z',
        lastUpdatedTimestamp: '2023-11-13T17:29:33.178Z',
        expectedBatches: 10,
        finalBatchStatusCount: 5,
        pendingBatchStatusCount: 5,
        simulationEvents: [],
        simulationBatchCreatorJobs: [],
      } as any,
    ]);
  },
  fetchSimulationRawResults: async (simulationId: string, date: string, hour: string, status: string, page: string) => {
    await delay();
    return Promise.resolve({} as any);
  },
  fetchSimulationSummaries: async (partnerId: string) => {
    await delay();
    return Promise.resolve([
      {
        simulationType: 'add_origin',
        simulationStatus: SimulationStatus.PROCESSING,
        executionStatus: SimulationExecutionStatus.ACTIVE,
        shipmentCount: 303303,
        description: 'Simulating Adding an origin in kansas',
        name: 'Add Kansas FC',
        simulationId: 'simulation_id_1',
      } as any,
      {
        simulationStatus: SimulationStatus.PROCESSING,
        executionStatus: SimulationExecutionStatus.ACTIVE,
        shipmentCount: 303303,
        description: 'Simulating Adding an origin in kansas',
        name: 'Add Kansas FC',
        simulationId: 'simulation_id_1',
      } as any,
    ]);
  },
  fetchSimulationUploads: async (partnerId: string) => {
    return [];
  },
  createSimulation: async (sim: any) => {
    return sim;
  },
  updateSimulation: async (sim: any) => {
    return sim;
  },
  updateSimulationShipmentBatch: async (batch: any) => {
    return batch;
  },
  fetchSimulationExports: async (simulationId: string) => {
    return [];
  },
  fetchSimulationReport: async (options: any) => {
    return {} as any;
  },
  createSimulationContextMappings: async (sim: any) => {
    return [] as any;
  },
  validateSimulationUpload: async (s3key: string) => {
    return {} as any;
  },
  createSimulationBatches: async () => {
    return {} as any;
  },
  fetchFulfillmentContextIDsByMethod: async () => {
    return {} as any;
  },
  archiveSimulation: async () => {
    return {} as any;
  },
  startSimulation: async (payload) => {
    return payload;
  },
  fetchSimulationSellRateMappings: async (payload) => {
    return [] as any;
  },
  fetchSimulationSellRateZoneMappings: async (payload) => {
    return {
      simulationId: payload,
      partnerId: '123',
      zones: [],
    };
  },
  createSimulationSellRateZoneMappings: async (payload) => {
    return [];
  },
  searchCarrierSellRateMappings: async (payload) => {
    return { mappings: [], params: {} };
  },
  deleteSellRateMappings: async (payload) => {
    return {
      deletedRecords: 1,
      carrierId: 'stirng',
      sellRateCarrierServiceMethodId: 'sellRateCarrierServiceMethodId',
      zoneId: 'zope',
      sellRateZoneId: 'string',
    };
  },
  deleteSimulationUpload: async (payload) => {
    return {} as any;
  },
  cleanupSimulationAssets: async (simulationId: string) => {
    return {
      deletedAssets: 0,
    };
  },
};
export default mockSimualtionService;
